import request from '@/utils/request'
const BASE_URL = '/PuCostShareDocCost'

export default {
  list(data) {
    return request({
      url: BASE_URL + '/List',
      method: 'post',
      data
    })
  },
  info(id) {
    return request({
      url: BASE_URL + '/Info',
      method: 'get',
      params: { id }
    })
  },
  save(data) {
    return request({
      url: BASE_URL + '/Save',
      method: 'post',
      data
    })
  },
  delete(id) {
    return request({
      url: BASE_URL + '/Delete',
      method: 'get',
      params: { id }
    })
  },
  getGoodsList(id) {
    return request({
      url: BASE_URL + '/getGoodsList',
      method: 'get',
      params: { id }
    })
  },
  getReceiptList(id) {
    return request({
      url: BASE_URL + '/getReceiptList',
      method: 'get',
      params: { id }
    })
  },
  addGoods(data) {
    return request({
      url: BASE_URL + '/addGoods',
      method: 'post',
      data
    })
  },
  updateGoods(data) {
    return request({
      url: BASE_URL + '/updateGoods',
      method: 'post',
      data
    })
  },
  deleteGoods(orderGoodsId) {
    return request({
      url: BASE_URL + '/deleteGoods',
      method: 'get',
      params: { orderGoodsId }
    })
  },
  examine(id) {
    return request({
      url: BASE_URL + '/Examine',
      method: 'get',
      params: { id }
    })
  },
  cancelExamine(id) {
    return request({
      url: BASE_URL + '/CancelExamine',
      method: 'get',
      params: { id }
    })
  },
  genSerialNo(id) {
    return request({
      url: BASE_URL + '/GenSerialNo',
      method: 'get',
      // params: { id }
    })
  },
}